import { type ReactElement, useState } from 'react'

import { Space } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-components/Form'
import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { CustomHomepageSettingsFieldProps } from '../types.js'

type CustomHomepageBaseFormFieldProp = CustomHomepageSettingsFieldProps & {
  defaultHomepage: Space
  label: string
  placeholder: string
  helperText: ReactElement
}

export const CustomHomepageBaseFormField = ({
  formKey,
  defaultValue,
  isLoading,
  defaultHomepage,
  label,
  placeholder,
  helperText,
}: CustomHomepageBaseFormFieldProp) => {
  const [currentValue, setCurrentValue] = useState<Space>(defaultValue)

  return (
    <Form.SpacePicker
      name={formKey}
      value={currentValue}
      disabled={isLoading}
      label={label}
      placeholder={placeholder}
      clearable
      onChange={(value: Space) => {
        return setCurrentValue(value)
      }}
      helperText={helperText}
      additionalIndicatorRenderer={space => {
        if (space.private) {
          return <SvgIcon className="text-content-subdued" name="lock" />
        }
        if (space.id === defaultHomepage?.id) {
          return (
            <span className="text-content-subdued italic">
              <T
                defaultMessage="(default homepage)"
                id="Admin.HomepageSettings.DefaultHomepageSelectHint"
              />
            </span>
          )
        }
        return null
      }}
    />
  )
}
